import { render } from "./IntercomDescribe.vue?vue&type=template&id=6b21abad&scoped=true"
import script from "./IntercomDescribe.vue?vue&type=script&lang=js"
export * from "./IntercomDescribe.vue?vue&type=script&lang=js"

import "./IntercomDescribe.vue?vue&type=style&index=0&id=6b21abad&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b21abad"]])

export default __exports__